import React, { useEffect, useState } from "react";
import {
  Divider,
  Grid2,
  Tab,
  Box,
  Paper,
  Typography,
  Stepper,
  StepButton,
  Step,
  StepLabel,
  Collapse,
  CircularProgress,
  DialogContent,
  Dialog,
  IconButton,
} from "@mui/material";

import PTWForm2 from "./PTWForm2";
import PTWForm1 from "./PTWForm1";
import { commonCss } from "../../StyleConfig/CommonCss";
import { useSearchParams } from "react-router-dom";
import { api, infoId, roleInfo } from "../API/config";
import { axiosPrivate } from "../../axios/axios";

import { TabContext, TabList, TabPanel } from "@mui/lab";
import Loading from "../../Component/Loading";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Print,
  Info,
} from "@mui/icons-material";
import RemarkTableView from "../../Component/RemarkTableView";
import AuditLogDialog from "../../Component/AuditLogDialog";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";

export default function MainForm() {
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = 2;

  const permitStatus = useSelector((state) => state.data.permitStatus);
  const isPermitShift = useSelector((state) => state.data.isPermitShift);
  const login = useSelector((state) => state.auth.loginInfo);
  const loginRoleId = String(login.roleIds).split(",");

  const [print, setPrint] = useState(false);
  const [auditLogOpen, setAuditLogOpen] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState({});
  const [value, setValue] = useState("1");
  const getRole = atob(searchParams.get("requestor")).toLowerCase();
  const [remarkButton, setRemarkButton] = useState({
    reject: false,
    cancel: false,
    remarkOpen:
      (data.isCancel &&
        data.otherRemarks !== null &&
        data.otherRemarks !== "") ||
      ((data.riskLevelId === infoId.low
        ? !data.isPermitIssuerApproved
        : !data.isLeadPermitIssuerApproved) &&
        data.rejectedRemarks !== null &&
        data.rejectedRemarks !== "")
        ? true
        : false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    const getDetailByid = api.PTWForm.getDetailById;
    await axiosPrivate
      .get(`${getDetailByid}/${atob(searchParams.get("id"))}`)
      .then((res) => {
        setData(res.data.data);

        setLoading(false);
        console.log(res);
      })
      .catch((e) => {
        setData({});
        setLoading(false);
        console.log(e, "MainForm");
      });
  };

  const handlePrint = (id, formNo) => {
    setPrint(true);
    const printlink = api.PTWForm.print;
    axiosPrivate
      .get(
        `${printlink}?id=${id}&&pageSize=a4&&printBackground=false&&margin=0`,
        {
          responseType: "blob",
        },
      )
      .then((res) => {
        console.log(res);
        const blob = res.data;
        saveAs(blob, `Form-${formNo}.pdf`);
        setPrint(false);
      })
      .catch((e) => {
        console.log(e);
        setPrint(false);
        toast.error(e.response.data.message);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const auditLogColumns = [
    {
      Header: "Reassigned From",
      accessor: "oldUserName",
    },
    {
      Header: "Reassigned To",
      accessor: "newUserName",
    },

    {
      Header: "Role",
      accessor: "roleName",
    },
    {
      Header: "Reassign Person",
      accessor: "reassignedByName",
    },
    {
      Header: "Approval User Name",
      accessor: "approvalUserName",
    },
    {
      Header: "Reassigned Date",
      accessor: "reassignedAt",
      Cell: ({ value }) =>
        value ? moment(value).format("DD/MM/YYYY HH:mm") : "",
    },
  ];

  return (
    <Paper
      sx={{
        background: "white",
        borderRadius: "10px",
        p: 1.5,
      }}
    >
      <Grid2 container size={12} spacing={"0.6rem"}>
        <Grid2 container size={12} justifyContent={"center"}>
          <Typography variant="h5" fontWeight="bold" color="rgb(0, 86, 151)">
            PSP PERMIT TO WORK FORM
          </Typography>
        </Grid2>
        <Grid2 container size={12}>
          <Grid2 size={{ xs: 6 }}>
            <Typography variant="body1" fontWeight="bold">
              Date of issue :{" "}
              {data !== null ? moment(data.issueDate).format("DD/MM/YYYY") : ""}
            </Typography>
          </Grid2>

          <Grid2 container size={{ xs: 6 }} justifyContent={"flex-end"}>
            <Grid2
              container
              size={{ xs: 12 }}
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              <Typography variant="body1" fontWeight="bold" sx={{ mr: 2 }}>
                {/* {data.formStatusText.toLowerCase()==="rejected"?null: */}

                {!data.isPermitClosed && !data.isCancel ? (
                  (data.riskLevelId === infoId.low
                    ? data.isPermitIssuerApproved
                    : data.isLeadPermitIssuerApproved) &&
                  moment().isAfter(
                    moment(data.piPermitValidUpTo).format("YYYY-MM-DD"),
                    "day",
                  ) ? (
                    // data.isFormExpired ?
                    <Typography
                      sx={{
                        fontSize: "inherit",
                        fontWeight: "inherit",
                        color: "rgb(0, 86, 151)",
                      }}
                    >
                      Expired
                    </Typography>
                  ) : (data.riskLevelId === infoId.low
                      ? data.isPermitIssuerApproved
                      : data.isLeadPermitIssuerApproved) &&
                    !data.isPHPermitClosed ? (
                    isPermitShift ? (
                      <Typography
                        sx={{
                          fontSize: "inherit",
                          fontWeight: "inherit",
                          color: "rgb(0, 86, 151)",
                        }}
                      >
                        Active
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "inherit",
                          fontWeight: "inherit",
                          color: "rgb(0, 86, 151)",
                        }}
                      >
                        Suspend
                      </Typography>
                    )
                  ) : null
                ) : null}
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                No.{" "}
                <span style={{ color: commonCss.red, fontSize: "1.2rem" }}>
                  {searchParams.get("no")}
                </span>
              </Typography>
              <IconButton
                disabled={data.formStatusText === "New"}
                onClick={() => {
                  handlePrint(data.id, data.seqNo);
                }}
              >
                <Print />
              </IconButton>
            </Grid2>
            <Grid2
              container
              size={{ xs: 12 }}
              justifyContent={"flex-end"}
              alignItems={"center"}
              gap={"1rem"}
            >
              <Typography>
                Total Hours :
                <span
                  style={{
                    color: "rgb(0, 86, 151)",
                    fontWeight: 500,
                    marginLeft: "0.5rem",
                  }}
                >
                  {data.totalDurationText === null ? 0 : data.totalDurationText}
                </span>
              </Typography>
              |
              <Typography>
                Total Working Days :
                <span
                  style={{
                    color: "rgb(0, 86, 151)",
                    fontWeight: 500,
                    marginLeft: "0.5rem",
                  }}
                >
                  {data.totalMandays}
                </span>
              </Typography>
              {data.isformreassigned && (
                <IconButton
                  size="small"
                  onClick={() => setAuditLogOpen(true)}
                  sx={{
                    color: commonCss.orange,
                    border: `1px solid ${commonCss.orange}`,
                    borderRadius: "4px",
                    backgroundColor: "rgba(255, 152, 0, 0.1)",
                    "&:hover": {
                      backgroundColor: "rgba(255, 152, 0, 0.2)",
                    },
                  }}
                  title="View Audit Log"
                >
                  <Info />
                </IconButton>
              )}
            </Grid2>
          </Grid2>
          <Divider
            sx={{ borderColor: commonCss.darkBlue, borderWidth: 1, width: "100%" }}
          />
        </Grid2>
        <Grid2 container size={12}>
          <Box
            sx={{
              width: "100%",
              ".MuiStepper-root": {
                overflowX: "auto",
                whiteSpace: "nowrap",
              },
            }}
          >
            <Stepper
              activeStep={
                permitStatus.currentStage === 0 && !data.isContractApproved
                  ? 0
                  : permitStatus.currentStage + 1
              }
              alternativeLabel
            >
              {permitStatus.formStages.map((label, index) => (
                <Step key={index}>
                  <StepLabel
                    sx={{
                      ".MuiStepIcon-root.Mui-completed": {
                        color: "rgb(0, 86, 151)",
                      },
                      ".MuiStepLabel-label.Mui-completed": {
                        color: "rgb(0, 86, 151)",
                      },
                      ".MuiStepIcon-root.Mui-active": {
                        color: "rgb(0, 86, 151)",
                      },
                      ".MuiStepLabel-label.Mui-active": {
                        color: "rgb(0, 86, 151)",
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Grid2>
        {loading ? null : (
          <Grid2
            container
            size={12}
            gap={0}
            sx={{
              display:
                data.isCancel ||
                ((data.riskLevelId === infoId.low
                  ? !data.isPermitIssuerApproved
                  : !data.isLeadPermitIssuerApproved) &&
                  data.rejectedRemarks !== null &&
                  data.rejectedRemarks !== "")
                  ? "default"
                  : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                cursor: "pointer",
              }}
              onClick={() => {
                setRemarkButton({
                  ...remarkButton,
                  remarkOpen: !remarkButton.remarkOpen,
                });
              }}
            >
              {remarkButton.remarkOpen ? (
                <KeyboardArrowUp sx={{ color: "rgb(0, 86, 151)" }} />
              ) : (
                <KeyboardArrowDown sx={{ color: "rgb(0, 86, 151)" }} />
              )}

              <Typography sx={{ color: "rgb(0, 86, 151)", ml: "0.6rem" }}>
                Remark
              </Typography>
            </Box>
            <Collapse
              in={remarkButton.remarkOpen}
              sx={{ backgroundColor: "white", width: "100%", p: 1 }}
            >
              {/* <Typography>{data.isCancel?data.otherRemarks:data.rejectedRemarks}</Typography> */}
              <RemarkTableView
                data={data.isCancel ? data.otherRemarks : data.rejectedRemarks}
              />
            </Collapse>
          </Grid2>
        )}
        <Grid2 container size={12}>
          <Box sx={{ width: "100%", typography: "body1", minHeight: "50vh" }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "rgb(0, 86, 151)",
                    },
                    "& .MuiTab-root.MuiTab-textColorPrimary.Mui-selected": {
                      color: "rgb(0, 86, 151)",
                    },
                  }}
                >
                  <Tab label="Page 1" value="1" />
                  <Tab label="Page 2" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ p: 0, pt: 1 }}>
                {loading ? (
                  <Loading color={commonCss.blue} />
                ) : (
                  <PTWForm1
                    data={data}
                    getData={getData}
                    onChangeTab={handleChange}
                    roleName={getRole}
                  />
                )}
              </TabPanel>
              <TabPanel value="2" sx={{ p: 0, pt: 1 }}>
                {loading ? (
                  <Loading color={commonCss.blue} />
                ) : (
                  <PTWForm2
                    data={data}
                    getData={getData}
                    onChangeTab={handleChange}
                    roleName={getRole}
                  />
                )}
              </TabPanel>
            </TabContext>
          </Box>
        </Grid2>
      </Grid2>
      <Dialog
        maxWidth={"sm"}
        open={print}
        onClose={() => {
          setPrint(true);
        }}
        PaperProps={{
          sx: {
            background: "white",
            borderRadius: "10px",
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "rgb(0, 86, 151)", fontWeight: 450 }}>
              Printing
            </Typography>
            <CircularProgress disableShrink sx={{ color: "rgb(0, 86, 151)" }} />
          </Box>
        </DialogContent>
      </Dialog>
      <AuditLogDialog
        open={auditLogOpen}
        onClose={() => setAuditLogOpen(false)}
        data={data.formReassignAuditLogs}
        columns={auditLogColumns}
      />
    </Paper>
  );
}
